import { httpClient } from '@/services/http/client'
import { buildApiUrl, ApiService } from '@/config/api.config'
import { residentialComplexApi } from '@/features/residential-complex/api/residentialComplexApi'
import type { ResidentialComplex } from '@/types/entities/residential-complex'
import type { Article } from '@/types/entities/article'

/**
 * API методы для Home feature
 */
export const homeApi = {
  /**
   * Получить избранные жилые комплексы
   * Использует POST запрос с фильтром featured: true
   */
  async getFeaturedComplexes(): Promise<ResidentialComplex[]> {
    const url = buildApiUrl(ApiService.Properties, 'properties/residential-complexes')
    const response = await httpClient.post<{ residentialComplexes: ResidentialComplex[] }>(url, {
      filter: {
        featured: 1, // RESIDENTIAL_COMPLEX_FEATURED_FILTER_TRUE
      },
      pagination: {
        page: 1,
        perPage: 10, // Достаточно для карусели
      },
    })
    return response.residentialComplexes || []
  },

  /**
   * Получить избранные статьи
   */
  async getFeaturedArticles(): Promise<Article[]> {
    const url = buildApiUrl(ApiService.Articles, 'articles/featured')
    const response = await httpClient.get<{ articles: Article[] }>(url)
    return response.articles || []
  },

  /**
   * DEV-1808: сколько всего проектов в публичном каталоге — цифра для hero.
   *
   * Своего запроса не заводим: residentialComplexApi.list строит тот же POST и
   * уже приводит uint64-строки protojson к числам (DEV-302). perPage=1 —
   * список нам не нужен, нужен только pagination.total, а не 10 полных
   * карточек мимо кассы.
   */
  async getProjectsTotal(): Promise<number> {
    const { pagination } = await residentialComplexApi.list({}, { page: 1, perPage: 1 })
    return pagination.totalCount
  },
}
